import axios from 'axios';

const updateSettings = params => axios.put('rcs/settings', params);

const acceptPolicy = () => axios.put('rcs/settings/accept');

export { updateSettings, acceptPolicy };
